import { createSlice } from "@reduxjs/toolkit";
import { getFromRestaurantsByCustomerAction, getToRestaurantsByCustomerAction, copyRestaurantMenuACTION } from "../../actions/copy-menu/copyMenuAction";

const INITIAL_STATE = {
    fromRestaurants: {
        data: [],
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    toRestaurants: {
        data: [],
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    copyRestaurantMenuDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
};

const copyMenuReducer = createSlice({
    name: "copyMenu",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetCopyMenuDetailsState(state, action) {
            state.fromRestaurants = INITIAL_STATE.fromRestaurants;
            state.toRestaurants = INITIAL_STATE.toRestaurants;
            state.copyRestaurantMenuDetails = INITIAL_STATE.copyRestaurantMenuDetails;
        },
    },
    extraReducers: (builder) => {
        // getFromRestaurantsByCustomerAction
        builder.addCase(getFromRestaurantsByCustomerAction.fulfilled, (state, action) => {
            state.fromRestaurants.data = action.payload?.Data?.Records || action.payload?.data?.records || action.payload?.data || [];
            state.fromRestaurants.apiMsg.status = action.meta.requestStatus;
            state.fromRestaurants.apiMsg.message = "success";
        });
        builder.addCase(getFromRestaurantsByCustomerAction.pending, (state, action) => {
            state.fromRestaurants.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getFromRestaurantsByCustomerAction.rejected, (state, action) => {
            state.fromRestaurants.apiMsg.message = action.error?.message;
            state.fromRestaurants.apiMsg.status = action.meta.requestStatus;
        });

        // getToRestaurantsByCustomerAction
        builder.addCase(getToRestaurantsByCustomerAction.fulfilled, (state, action) => {
            state.toRestaurants.data = action.payload?.Data?.Records || action.payload?.data?.records || action.payload?.data || [];
            state.toRestaurants.apiMsg.status = action.meta.requestStatus;
            state.toRestaurants.apiMsg.message = "success";
        });
        builder.addCase(getToRestaurantsByCustomerAction.pending, (state, action) => {
            state.toRestaurants.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getToRestaurantsByCustomerAction.rejected, (state, action) => {
            state.toRestaurants.apiMsg.message = action.error?.message;
            state.toRestaurants.apiMsg.status = action.meta.requestStatus;
        });

        // copyRestaurantMenuACTION
        builder.addCase(copyRestaurantMenuACTION.fulfilled, (state, action) => {
            state.copyRestaurantMenuDetails.data = action.payload;
            state.copyRestaurantMenuDetails.apiMsg.status = action.meta.requestStatus;
            state.copyRestaurantMenuDetails.apiMsg.message = "success";
        });
        builder.addCase(copyRestaurantMenuACTION.pending, (state, action) => {
            state.copyRestaurantMenuDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(copyRestaurantMenuACTION.rejected, (state, action) => {
            state.copyRestaurantMenuDetails.apiMsg.message = action.error?.message;
            state.copyRestaurantMenuDetails.apiMsg.status = action.meta.requestStatus;
        });
    },
});

export const { RESET, ResetCopyMenuDetailsState } = copyMenuReducer.actions;
export default copyMenuReducer.reducer;
